import SalesTerms from '../../../../components/sales-terms-short-description/sales-terms-short-description.desktop';
import salesTerms from './sales-terms-short-description';

export default salesTerms(SalesTerms);
